package game.controller

import Button
import ButtonEvent
import com.soywiz.kds.FastArrayList
import com.soywiz.kds.iterators.fastForEach
import com.soywiz.korge.input.Input
import com.soywiz.korma.geom.Rectangle
import com.soywiz.korma.geom.contains
import game.Game
import view.CharMouseEvent
import view.Terminal

abstract class GameController {
    private var mouseDown = false
    private val components = FastArrayList<Component>()
    private var hoverComponent: Component? = null
    private var pressedComponent: Component? = null

    lateinit var nextController: GameController
    open fun onActivate(game: Game) {}
    open fun onDeactivate(game: Game) {}
    open fun onTick(game: Game, input: Input) {}
    open fun onFrame(game: Game, input: Input) {}
    open fun onMouseDownChar(game: Game, event: CharMouseEvent) {}
    open fun onMouseUpChar(game: Game, event: CharMouseEvent) {}
    open fun onMouseEnterChar(game: Game, event: CharMouseEvent) {}
    open fun onMouseExitChar(game: Game, event: CharMouseEvent) {}

    open fun onRender(game: Game, terminal: Terminal) {}

    fun activate(game: Game) {
        onActivate(game)
    }

    fun deactivate(game: Game) {
        components.clear()

        onDeactivate(game)
    }

    fun render(game: Game, terminal: Terminal) {
        onRender(game, terminal)
        renderComponents(game, terminal)
    }

    fun tick(game: Game, input: Input) {
        onTick(game, input)
    }

    fun frame(game: Game, input: Input) {
        onFrame(game, input)
    }

    fun addLabel(text: String, col: Int, row: Int, width: Int, height: Int): Label {
        val label = Label(text, col, row, width, height)

        components.add(label)

        return label
    }

    fun addButton(text: String, col: Int, row: Int, width: Int, height: Int, onClick: ButtonEvent = {}): Button {
        val button = Button(text, col, row, width, height)

        button.onClick = onClick

        components.add(button)

        return button
    }

    fun addCheckBox(
        text: String,
        col: Int,
        row: Int,
        width: Int,
        height: Int,
        checked: Boolean,
        onCheck: CheckEvent = { _, _ -> }
    ): CheckBox {
        val checkBox = CheckBox(text, col, row, width, height, checked)

        checkBox.onCheck = onCheck

        components.add(checkBox)

        return checkBox
    }

    fun renderComponents(game: Game, terminal: Terminal) {
        components.fastForEach {
            if (it.visible) {
                it.render(game, terminal)
            }
        }
    }

    fun getComponentAt(col: Int, row: Int): Component? {
        return components.firstOrNull {
            it.visible && Rectangle(it.col, it.row, it.width, it.height).contains(col, row)
        }
    }

    fun removeAllComponents() {
        components.clear()
    }

    fun mouseDownChar(game: Game, event: CharMouseEvent) {
        mouseDown = true
        val component = getComponentAt(event.col, event.row)

        pressedComponent = component
        hoverComponent = component
        pressedComponent?.down(game)

        onMouseDownChar(game, event)
    }

    fun mouseUpChar(game: Game, event: CharMouseEvent) {
        mouseDown = false

        hoverComponent?.up(game)

        if (hoverComponent == pressedComponent) {
            pressedComponent?.click(game)
        }

        onMouseUpChar(game, event)

        pressedComponent = null

    }

    fun mouseEnterChar(game: Game, event: CharMouseEvent) {
        if (mouseDown) {
            val button = getComponentAt(event.col, event.row)

            if (button != hoverComponent) {
                hoverComponent?.up(game)
                hoverComponent = button
                hoverComponent?.down(game)
            }

            onMouseEnterChar(game, event)
        }
    }

    fun mouseExitChar(game: Game, event: CharMouseEvent) {
        onMouseExitChar(game, event)
    }
}
